"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var RawTextBlock =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(RawTextBlock, _Block);

  function RawTextBlock() {
    babelHelpers.classCallCheck(this, RawTextBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RawTextBlock).apply(this, arguments));
  }

  return RawTextBlock;
}(_base.default);

exports.default = RawTextBlock;